import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/sagas/utilization";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";

export const FilterByClass = () => {
  const dispatch = useDispatch();

  const options = useSelector((state) => state.utilization.filters.class_values);
  const selectedFilters = useSelector((state) => state.utilization.selectedClassFilters);
  const classFiltersLoading = useSelector((state) => state.utilization.classFiltersLoading);

  return (
    <div className="select-box" style={{ width: "200px" }}>
      <p className="offers-title">Class</p>
      {!classFiltersLoading ? (
        <MultiSelectDropdown
          options={options}
          selectedFilters={selectedFilters}
          placeholder="Select Classes"
          enableOnly
          numberDisplayed={0}
          includeSelectAll
          onSelectChange={(data) => dispatch(actionCreators.updateDataByClass(data))}
        />
      ) : (
        <button className="picky__input">
          <LoadingAnimation uiLoader />
        </button>
      )}
    </div>
  );
};
